import { FullPageWrapperContext } from 'global/cnr/contexts/FullPageWrapperContext';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { UiItemContext } from '../cnr/contexts/UiItemContext';
import { cnnAdd } from '../common/cns';
import { appIconTypes } from '../enums/appIconTypes';
import { gEnums } from '../enums/globalEnums';
import GenericIcon from '../genericControls/GenericIcon';
import { _animateTypes } from '../motions/AnimateComponent';
import { ItemActionContext } from '../pageItem/modification/UiItemAction';
import { PageItemOptionsContext } from '../sidebars/PageItemOptionsMenu';
import { _longPressDisplayTypes } from './LongPressWrapper';
import { H2Topper, H3Topper } from './TopperWrappers';
import Wrapper from './Wrapper';
import { LongPressContext } from 'global/cnr/contexts/LongPressContext';
import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation';
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles';

/**
 * 
 * @param {object} props (
 *  content,
    halfModal,
    handleCancel,
    isBack,
    isSub,
    noModal,
    topperCaption,
    topperCaption2,
    topperHeader)
 * @returns 
 */
const FullPageWrapper = (props) => {

  const navigate = useNavigate();

  const {
    fullMode,
    useModalPage,
    isModal_fpw,
    longPressDisplayType,
  } = props

  const upn = usePageNavigation()
  const { setStyleAndClass } = useStyles()

  const fullPageWrapperContext = useContext(FullPageWrapperContext)
  const { fullPageWrapper_state, fullPageWrapper_handlers } = fullPageWrapperContext ?? {}
  const { fpwProps, wideModeOn } = fullPageWrapper_state ?? {}

  const longPressContext = useContext(LongPressContext)
  const { longPress_handlers } = longPressContext ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers, fns } = parentContext ?? {}
  const { page_state, transition_state } = states ?? {}
  const { serviceWorker_handlers } = handlers ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {})

  const { pageNav } = page_state ?? {}
  const { navUiItemContext } = pageNav ?? {}
  const { dataOptions } = aps_global ?? {}
  const { useModifyRoutes } = dataOptions ?? {}

  // itemActionContext
  const itemActionContext = useContext(ItemActionContext);
  const { uiItemContext: uiItemContext_alt } = itemActionContext ?? {}

  // pageItemOptionsContext
  const pageItemOptionsContext = useContext(PageItemOptionsContext)
  const { pageItemOptions_fns } = pageItemOptionsContext ?? {}
  const { handleCancel: handleCancel_pio } = pageItemOptions_fns ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { frameworkRightType, frameworkLeftType, isMobileDevice } = framework_state ?? {}
  const { handleKill_pageNav } = framework_handlers ?? {}

  const { transitions } = transition_state ?? {}
  const transition_fpw = transitions ? transitions[_animateTypes.fullPageWrapper] : null

  const { projectOptions } = aps_global ?? {}
  const { useCloseModalSwipe } = projectOptions ?? {}

  const [_fpwProps, set_fpwProps] = useState({})

  useEffect(() => {
    if (!useModalPage) {
      set_fpwProps(props)
    }
    if (useModalPage && !fpwProps) {
      fullPageWrapper_handlers.handleInit_fpw(props)
    }
    // fullPageWrapper_handlers.handleWideMode(fullMode)
  }, [props, useModalPage]);

  useEffect(() => {
    fullPageWrapper_handlers.handleWideMode(fullMode)
  }, [fullMode]);

  useEffect(() => {
    if (fpwProps) {
      const _navProps = { modalMode: 'goodbye' }
      upn.handleNav(_navProps)
    }
  }, [fpwProps]);

  useEffect(() => {
    if (isModal_fpw && fpwProps) {
      set_fpwProps(fpwProps)
    }
  }, [isModal_fpw]);

  const {
    allowReload,
    allowRefresh,
    css,
    content,
    fullWebPage,
    halfModal,
    cancelOptions,
    handleRefresh,
    ignoreStyle,
    isBack,
    isSub,
    noModal,
    topperCaption,
    topperCaption2,
    topperHeader,
    updating,
    wrapperCss,
  } = _fpwProps

  if (!_fpwProps) {
    return <div>---</div>
  }

  let topSac = setStyleAndClass({ item: gEnums.projectStyles.topMenu })
  if (ignoreStyle) { topSac = {} }

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);

  // LOOK
  let _uiItemContext = navUiItemContext ? navUiItemContext : uiItemContext
  _uiItemContext = uiItemContext_alt ? uiItemContext_alt : _uiItemContext

  const { item_handlers, item_state } = _uiItemContext ?? {}
  const { editableItem } = item_state ?? {}
  const { handleClose_openedItem, handleShow_itemEdit } = item_handlers ?? {}

  const handleWide = () => fullPageWrapper_handlers.handleWideMode(!wideModeOn)

  const handleReload = () => {
    if (allowRefresh) {
      window.location.reload()
    } else if (allowReload) {
      serviceWorker_handlers.handleClear_refresh()
    }
  }

  const wideModeAvailable = fullMode  //&& !isMobileDevice

  const _handleCancel = useMemo(() => {
    let _hc = props.handleCancel
    if (!_hc && _fpwProps?.handleCancel) { _hc = _fpwProps.handleCancel }
    if (!_hc && handleClose_openedItem) { _hc = handleClose_openedItem }
    if (!_hc && handleCancel_pio) { _hc = handleCancel_pio }
    if (!_hc && editableItem) { _hc = handleShow_itemEdit }
    if (!_hc && longPress_handlers?.handleCancel) { _hc = longPress_handlers.handleCancel }
    return _hc
  }, [])


  const handle_cancel = () => {

    // if (longPressDisplayType) { console.log('longPressDisplayType FPW', longPressDisplayType) }

    if (isBack && useModifyRoutes) {
      navigate(-1)
    } else {
      if (longPressDisplayType === _longPressDisplayTypes.full) {
        window.history.back();
      }
      _handleCancel()
      handleKill_pageNav && handleKill_pageNav()
    }
  }

  const buttonProps_cancel = { color: 'black', inverted: true }
  const buttonProps_redo = { color: 'grey', inverted: false }

  const gi = (key, iconName, onClick, clickOptions, opts, corner) => <GenericIcon giProps={{ key, iconName, onClick, clickOptions, opts, corner }} />

  const infoButton = () => gi('btn-cancel', appIconTypes.check, null, null, { ...buttonProps_cancel, nb: false, nf: true })
  const cancelButton = () => gi('btn-cancel', isBack ? appIconTypes.arrowLeft : appIconTypes.delete, handle_cancel, cancelOptions, { ...buttonProps_cancel, nb: false, nf: true })
  const refreshButton = () => gi('btn-refresh', appIconTypes.refresh, handleRefresh, null, { ...buttonProps_cancel, nb: true, nf: true })
  const wideModeButton = () => gi('btn-cancel', wideModeOn ? 'square outline' : appIconTypes.wideMode, handleWide, null, { ...buttonProps_cancel, nb: false, nf: true })
  const reloadButton = () => gi('btn-redo', allowRefresh ? 'redo' : 'sync', handleReload, null, { ...buttonProps_redo, nb: false, nf: true })

  const toppers = () => <React.Fragment>
    <div>{topperCaption}</div>
    <div style={{ paddingTop: '.5em', wordBreak: 'break-word' }} >{topperCaption2}</div>
  </React.Fragment>

  const topper1 = () => <H2Topper
    leftContent={infoButton()}
    rightContent={topperCaption2 ? toppers() : topperCaption}
  ></H2Topper>

  const topper2 = () => <H2Topper
    leftContent={_handleCancel && cancelButton()}
    rightContent={topperCaption2 ? toppers() : topperCaption}
  ></H2Topper>

  const topper3 = () => <H3Topper
    leftContent={_handleCancel && cancelButton()}
    middleContent={topperCaption2 ? toppers() : topperCaption}
    rightContent={handleRefresh && refreshButton()}
  />

  const topper3_reload = () => <H3Topper
    leftContent={_handleCancel && cancelButton()}
    middleContent={topperCaption2 ? toppers() : topperCaption}
    rightContent={reloadButton()}
  />

  const topper3Wide = () => <H3Topper
    leftContent={_handleCancel && cancelButton()}
    middleContent={topperCaption2 ? toppers() : topperCaption}
    rightContent={wideModeButton()}
  />

  const topper = () => {
    switch (handle_cancel) {
      case _longPressDisplayTypes.full:
        return topper2();
      default:
      // nothing
    }
    if (fullWebPage) {
      return topper1()
    } else if (handleRefresh) {
      return topper3()
    } else if (wideModeAvailable) {
      return topper3Wide()
    } else if (allowReload || allowRefresh) {
      return topper3_reload()
      // } else if (isOverlay) {
      //   if (isSidebar) {
      //     return topper2();
      //   } else {
      //     return;
      //   }
    } else {
      return topper2()
    }
  }

  let cn_fpw = 'fpw'
  if (isSub) { cn_fpw += ' sub' }
  if (css) {
    const { container: css_container } = css ?? {}
    cn_fpw = cnnAdd(cn_fpw, css_container)
    if (css.header) {
      topSac.className = css.header
    }
  }

  // return <div>FPW</div>

  const wrapper = () => <Wrapper
    topper={topper()}
    handleSwipedRight={useCloseModalSwipe ? _handleCancel : null}
    header={topperHeader}
    content={content}
    css={{ container: cn_fpw, topper: topSac?.style }}
    modal={noModal ? false : true}
    halfModal={halfModal}
    fullMode={wideModeOn}
    fullWebPage={fullWebPage}
    transition_fpw={transition_fpw}
    wrapperCss={wrapperCss}
    updating={updating}
    longPressDisplayType={longPressDisplayType}
    useModalPage={useModalPage}
  />

  return (frameworkRightType || frameworkLeftType) ? content : wrapper()

}

export default FullPageWrapper

